import { Component } from "@angular/core";
import { ProcessCollectionComponent } from "process/table/process-collection.component";
import { AsyncPipe, NgTemplateOutlet } from "@angular/common";
import { DescriptionViewComponent } from "common/editor/description-view.component";
import { RouterLink } from "@angular/router";

@Component({
	selector: "stages-process-table",
	templateUrl: "./process-table.component.html",
	styleUrls: ["./process-table.component.scss"],
	imports: [DescriptionViewComponent, RouterLink, NgTemplateOutlet, AsyncPipe],
})
export class ProcessTableComponent extends ProcessCollectionComponent {
	columns: unknown;

	constructor() {
		super();
	}
}
